module.exports = __webpack_public_path__ + "static/media/OM.3ec57fe0.svg";